// extracted by mini-css-extract-plugin
export default {"actions":"ViewStatementActions_actions__qukaE","action":"ViewStatementActions_action__+t2-7","loading":"ViewStatementActions_loading__piuC7"};